export enum CypressVariables {
	Banners = 'banners',
}
